import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Help from './../components/Help';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    ...state.help,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Help);
